import React from 'react'
import { levelNames, textInterface } from './types'
const colors = require('../colors.json')
export const LevelMeaning = ({ level, text }: { level: levelNames ,text:textInterface}) => {
  return (
    <div className='levelmeaningwrapper'>
      <div className='swatchWrapper'>
        {Object.keys(colors.hazards).map((k, i) => {
          return (
            <div
              key={i}
              className='swatch'
              style={{ backgroundColor: colors.hazards[k][level] }}
            />
          )
        })}
      </div>
      <p>{text.levelmeaning.levels[level]}</p>
    </div>
  )
}
